import { createSelector } from 'reselect';

// selectors
const getTopPerformers = (state) => state.topPerformers;
const getLoading = (state) => state.loading?.isLoading;
const getLanguage = (state) => state.config?.language;
const getDeviceInteraction = (state) => state.config?.deviceInteraction;

// reselect function
export const getTopPerformersState = createSelector(
    [getTopPerformers, getLoading, getLanguage, getDeviceInteraction],
    (topPerformers, isLoading, language, deviceInteraction) => (
        {
            ...topPerformers,
            isLoading,
            language,
            deviceInteraction
        }
    )
);
